<div class="bg-color-base-2500 h-100vh">
    <grid-row class="justify-content-center align-content-center h-100">
        <grid-col col="4" mobile="11" class="text-align-center"> 
            <ng-icon iconClass="icon-success-100px" width="100" height="100" *ngIf="this.Decline == false"></ng-icon>
            <ng-icon iconClass="icon-error" width="100" height="100" *ngIf="this.Decline == true"></ng-icon>
            <!-- <div  *ngIf="this.Decline != false &&  this.Decline != true">
                <div class="font-500 font-size-32px color-base-100 line-h-40 mt-40">
                    {{ "ApplicationUnderReview" | translate }}
                </div>
                <div class="font-400 font-size-20px color-primary-shade-200 mt-10">
                    {{ "NotifiedBusinessDays" | translate }}
                </div>
            </div>
            <div *ngIf="this.Decline == false">
                <div class="font-500 font-size-32px color-base-100 line-h-40 mt-40">
                    {{ "CardLimitSuccess" | translate }}
                </div>
                
            </div>-->
            <div *ngIf="this.Decline == true">
                <div class="font-500 font-size-32px color-base-100 line-h-40 mt-40">
                    {{ "DeclineCardLimit" | translate }}
                </div>
                
            </div> 
            <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3" *ngIf="this.Decline == false">
                {{"YouSuccessfullyChanged" | translate}}
            </div>
            <grid-row class="justify-content-center mt-50">
                <grid-col col="8">
                    <button class="btn-dft-border" (click)="Dashboard()">
                        {{ "Done" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </grid-col>
    </grid-row>
</div>

